import AboutLocation from './AboutLocation';
import AboutBlock from './AboutBlock';
export default function About() {
    return(
        <div className="about">
            <AboutBlock/>
            <AboutLocation/>
        </div>
    );
}